export default {
  'myLocation': {
    'stopShowingCurrentLocation': 'Cliquez pour arrêter d\'afficher votre position actuelle',
    'showCurrentLocation': 'Cliquez pour afficher votre position actuelle',
    'yourCurrentLocation': 'Votre location actuelle',
    'continuously': 'En continu',
    'onlyOnce': 'Une fois',
    'continuouslyLocation': 'Actualisez votre position toutes les 2 secondes',
    'onlyOnceLocation': 'Acquérez votre position une seule fois',
    'myPositionToolTip': 'Activez la localisation pour afficher votre position et trouver plus facilement des lieux à proximité'
  }
}
